export default __webpack_public_path__ + "media/images/features/ja/map_line_4-7f38b3d15c3ca089c6d885830b14d5bd.png";